export const ROOT = 'https://www.silverfernfarms.com';
export const CONTACT_US = `${ROOT}/contact-us/`;
export const OUR_COMPANY = `${ROOT}/our-company/`;

export const SHARE_INFO = 'https://www.silverfernfarms.coop/dividends';
